// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__iXzB-","tooltip-box":"style_tooltip-box__75v0d","tooltip-box__popup":"style_tooltip-box__popup__wJS1G"};